// FILE: src/services/dealerAPI.js  — COMPLETE VERSION
 
import axios from 'axios';
 
const API_BASE_URL = process.env.REACT_APP_API_URL ? (process.env.REACT_APP_API_URL + '/api/v1') : '/api/v1';

const dealerAxios = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});
 
dealerAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('dealerToken') || localStorage.getItem('authToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);
 
dealerAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('dealerToken');
      localStorage.removeItem('dealer');
      localStorage.removeItem('dealerUser');
      localStorage.removeItem('authToken');
      window.location.href = '/dealer/login';
    }
    return Promise.reject(error);
  }
);
 
export const dealerAPI = {
  // ── Auth ──────────────────────────────────────────────────────────────────
  login:  (email, password) => dealerAxios.post('/login', { email, password }),
  logout: ()               => dealerAxios.delete('/logout'),
 
  // ── Profile ───────────────────────────────────────────────────────────────
  getProfile:    ()     => dealerAxios.get('/dealer/profile'),
  updateProfile: (data) => dealerAxios.put('/dealer/profile', data),
 
  // ── Auction Listings (bid on cars) ────────────────────────────────────────
  getListings:      ()   => dealerAxios.get('/dealer/dealer_listings'),
  getListingDetail: (id) => dealerAxios.get(`/dealer/dealer_listings/${id}`),
  getBiddingStatus: (id) => dealerAxios.get(`/dealer/dealer_listings/${id}/bidding_status`),
 
  // ── Offers (bids) ─────────────────────────────────────────────────────────
  placeBid: (listingId, offerPrice) =>
    dealerAxios.post(`/dealer/dealer_listings/${listingId}/dealer_offers`, {
      offer_price: offerPrice,
    }),
  getMyOffers: () => dealerAxios.get('/dealer/dealer_offers/my_offers'),
 
  // ── Bid Payments ──────────────────────────────────────────────────────────
  initiatePayment: (offerId, { phone, paymentMethod }) =>
    dealerAxios.post(`/dealer/dealer_offers/${offerId}/payment/initiate`, {
      phone,
      payment_method: paymentMethod,
    }),
  confirmPayment: (offerId, { razorpayOrderId, razorpayPaymentId, razorpaySignature }) =>
    dealerAxios.post(`/dealer/dealer_offers/${offerId}/payment/confirm`, {
      razorpay_order_id:   razorpayOrderId,
      razorpay_payment_id: razorpayPaymentId,
      razorpay_signature:  razorpaySignature,
    }),
  getPaymentStatus: (offerId) =>
    dealerAxios.get(`/dealer/dealer_offers/${offerId}/payment/status`),
 
  // ── Listing Credits ───────────────────────────────────────────────────────
  getListingCreditPlans: () =>
    dealerAxios.get('/dealer/listing_credits/plans'),
  initiateListingCreditPurchase: (plan) =>
    dealerAxios.post('/dealer/listing_credits/initiate', { plan }),
  confirmListingCreditPurchase: ({ razorpayOrderId, razorpayPaymentId, razorpaySignature }) =>
    dealerAxios.post('/dealer/listing_credits/confirm', {
      razorpay_order_id:   razorpayOrderId,
      razorpay_payment_id: razorpayPaymentId,
      razorpay_signature:  razorpaySignature,
    }),
  // ✅ FIX: Added missing getCreditPurchaseHistory
  getCreditPurchaseHistory: () =>
    dealerAxios.get('/dealer/listing_credits/history'),
 
  // ── Bidding Passes ────────────────────────────────────────────────────────
  getBiddingPassPlans: () =>
    dealerAxios.get('/dealer/bidding_passes/plans'),
  initiateBiddingPassPurchase: (plan) =>
    dealerAxios.post('/dealer/bidding_passes/initiate', { plan }),
  confirmBiddingPassPurchase: ({ razorpayOrderId, razorpayPaymentId, razorpaySignature }) =>
    dealerAxios.post('/dealer/bidding_passes/confirm', {
      razorpay_order_id:   razorpayOrderId,
      razorpay_payment_id: razorpayPaymentId,
      razorpay_signature:  razorpaySignature,
    }),
  // ✅ FIX: Added missing getPassPurchaseHistory
  getPassPurchaseHistory: () =>
    dealerAxios.get('/dealer/bidding_passes/history'),
 
  // ── Dealer Car Listings (sell flow) ───────────────────────────────────────
  getMyCarListings: () =>
    dealerAxios.get('/dealer/dealer_car_listings'),
  getMyCarListing: (id) =>
    dealerAxios.get(`/dealer/dealer_car_listings/${id}`),
  createCarListing: (formData) =>
    dealerAxios.post('/dealer/dealer_car_listings', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  updateCarListing: (id, formData) =>
    dealerAxios.put(`/dealer/dealer_car_listings/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
};
 
export default dealerAxios;